import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { LuXCircle } from 'react-icons/lu';

type CartEmptyProps = {
  className?: {
    main?: string;
    title?: string;
    button?: string;
    icon?: string;
  };
};

export function CartEmpty({ className }: CartEmptyProps) {
  const { t } = useTranslations();


  return (
    <div
      className={cn(
        'flex h-full min-h-[400px] w-full flex-col items-center justify-center space-y-6 px-4 pb-[100px] pt-[158px] sm:pt-[180px] lg:pt-[258px]',
        'ea-empty-cart',
        className?.main,
      )}
    >
      <LuXCircle className={cn('h-24 w-24 text-red-500', 'ea-empty_cart__icon', className?.icon)} />
      <h1
        className={cn(
          'mb-5 text-center text-3xl font-bold',
          'ea-empty-cart__title',
          className?.title,
        )}
      >
        {t('text171')}
      </h1>
      <Button asChild className={cn('ea-empty-cart__button', className?.button)}>
        <a href="/">{t('text517')}</a>
      </Button>
    </div>
  );
}
